<template>
  <div class="container">
    <h1>Workshops</h1>
    <h2>Craniosacrale Energiebalance am Pferd</h2>
    <img src="../assets/img/workshop/WS-12.jpg" width="800" alt="Katharina Herda erklärt Zusammenhänge am Pferd" />


    <p><b>Einführung in der Craniosacrale Arbeit und ihre Anwendungsbereiche beim Pferd.</b></p> 
    <p>Die Teilnehmer werden in ihrer Wahrnehmung geschult, potentielle Probleme und 
      Defizite beim Pferd zu erkennen und kleine Korrekturen selbst vornehmen zu 
      können – sehen, fühlen, unterstützen.</p>

    <p>Zielgruppe:Pferdebesitzer</p>

    <p><b>Inhalte</b></p>
    <ul class="list">
      <li>Einführung in die Craniosacrale Arbeit</li>
      <li>Anwendungsbereiche beim Pferd</li>
      <li>Blickschulung am Pferd</li>
      <li>Fühlen lernen - Was verrät mir der Pferdekörper</li>
      <li>Frühzeitiges Erkennen von Problemen</li>
      <li>Point of Balance</li>
      <li>Platz für individuelle Fragen</li>
    </ul>

    <p>Termine für 2022 in Planung.</p>


    <h2>Workshops auf Anfrage</h2>
      <p>Mein Repatoire erstreckt über sehr unterschiedliche Themen. Wenn sie über einen Workshop 
        oder ein Seminar bei sich (z.B. im Stall) nachdenken, melden Sie sich gerne bei mir.
        Es sind verschiedene Modelle, passend zu Ihren individuellen Bedürfnissen möglich.</p> 
      
      <div class="flex-container">
        <div class="flex-item">
          <img src="../assets/img/workshop/WS-8.jpg" width="300" alt="Katharina Herda bei der Blickschulung mit einer Kursteilnehmerin" />
        </div>
        <div class="flex-item">
          <img src="../assets/img/workshop/WS-3.jpg" width="300" alt="Katharina Herda zeigt Mobilisationsübungen am Vorderbein des Pferdes" />

        </div>
      </div>
      <p><b>Beispiele für Themenbereiche:</b></p>
      <ul class="list">
        <li>Craniosacrale Arbeit für Pferdebesitzer</li>
        <li>Gesunderhaltung des eigenen Körpers</li>
        <li>Cranio für Hufbearbeiter und Hufschmiede</li>
        <li>uvm.</li>
      </ul>
      <p><router-link :to="{ path: 'kontakt' }" class="block margin-tb">Zu meinen Kontaktdaten</router-link> </p>
  </div>
</template>

<script>
export default {
  name: "Workshops", //this is the name of the component
  metaInfo() {
      return { 
          title: "Workshops - Katharina Herda",
          meta: [
            { name: 'description', content: 'Katharina Herda referiert leidenschaftlich und mit immensem Fachwissen zu verschiedenen Themen: -Craniosacrale Energiebalance für Pferdebesitzer -Gesunderhaltung des Körpers -Craniosacrale Enerbalance für Hufbearbeiter und Hufschmiede, uvm.' },
            { property: 'og:title', content: "Workshops - Katharina Herda"},
            { property: 'og:description', content: 'Katharina Herda referiert leidenschaftlich und mit immensem Fachwissen zu verschiedenen Themen: -Craniosacrale Energiebalance für Pferdebesitzer -Gesunderhaltung des Körpers -Craniosacrale Enerbalance für Hufbearbeiter und Hufschmiede, uvm.'}, 
            { property: 'og:image', content: 'src/img/assets/workshop/WS-12.png'},
            { property: 'og:url', content: 'www.herda.at/workshops'}
          ]
      }
  } 
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/Workshops.vue